/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShipmentLocationInfo
 */
export interface ShipmentLocationInfo {
  /**
   *
   * @type {string}
   * @memberof ShipmentLocationInfo
   */
  city: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentLocationInfo
   */
  stateOrProvinceCode: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentLocationInfo
   */
  businessName: string;
}

/**
 * Check if a given object implements the ShipmentLocationInfo interface.
 */
export function instanceOfShipmentLocationInfo(
  value: object,
): value is ShipmentLocationInfo {
  if (!("city" in value) || value["city"] === undefined) return false;
  if (
    !("stateOrProvinceCode" in value) ||
    value["stateOrProvinceCode"] === undefined
  )
    return false;
  if (!("businessName" in value) || value["businessName"] === undefined)
    return false;
  return true;
}

export function ShipmentLocationInfoFromJSON(json: any): ShipmentLocationInfo {
  return ShipmentLocationInfoFromJSONTyped(json, false);
}

export function ShipmentLocationInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentLocationInfo {
  if (json == null) {
    return json;
  }
  return {
    city: json["city"],
    stateOrProvinceCode: json["stateOrProvinceCode"],
    businessName: json["businessName"],
  };
}

export function ShipmentLocationInfoToJSON(json: any): ShipmentLocationInfo {
  return ShipmentLocationInfoToJSONTyped(json, false);
}

export function ShipmentLocationInfoToJSONTyped(
  value?: ShipmentLocationInfo | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    city: value["city"],
    stateOrProvinceCode: value["stateOrProvinceCode"],
    businessName: value["businessName"],
  };
}
